export default __webpack_public_path__ + "static/media/resourceTypeImg.7c110406.png";